interface CompactSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
  totalResults?: number;
  isLoading?: boolean;
  showResultsCounter?: boolean;
}

export function CompactSearchBar({
  value,
  onChange,
  onClear,
  placeholder = 'Search...',
  totalResults,
  isLoading = false,
  showResultsCounter = false,
}: CompactSearchBarProps) {
  return (
    <div>
      {/* Search Input */}
      <div className='relative'>
        <input
          type='text'
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          className='w-full rounded-lg border border-gray-300 bg-card px-4 py-3 pr-11 text-foreground outline-none placeholder:text-muted-foreground focus:border-brand-400 focus:outline-none focus-visible:outline-none dark:border-gray-600 dark:placeholder:text-muted-foreground dark:focus:border-primary max-sm:text-base'
          disabled={isLoading}
        />
        {value && (
          <button
            onClick={onClear}
            // A 44px square flush to the field's right edge; the glyph sits
            // where the old `right-3` put it.
            className='absolute right-0 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center text-xl text-muted-foreground transition-colors hover:text-muted-foreground'
            aria-label='Clear search'
          >
            ✕
          </button>
        )}
        {isLoading && (
          <div className='absolute right-3 top-1/2 -translate-y-1/2'>
            <div className='h-5 w-5 animate-spin rounded-full border-2 border-brand-500 border-t-transparent dark:border-primary'></div>
          </div>
        )}
      </div>

      {/* Results Counter - Only show if enabled and has results */}
      {showResultsCounter && totalResults !== undefined && totalResults > 0 && (
        <div className='mt-2 text-center text-sm text-muted-foreground'>
          {totalResults} {totalResults === 1 ? 'result' : 'results'} found
        </div>
      )}
    </div>
  );
}
